import React, { useEffect, useRef, useState } from "react";
import DialogWhatsAppAuth from "./DialogWhatsAppAuth";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import { Close } from "@material-ui/icons";

export default function ModalWhatsAppAuth({
	open,
	onClose,
	status = "PROCESS",
	isLoading,
    handleFinalizeAuth,
	checkoutInformation = null,
	schedulingServicePackage = null,
	questions = [],
	observation = "",
	onFinalizeAppointment = null,
	observationTextField = null,
	setErrorObservation = null,
	onStartLoading = null,
	checkoutLoading = false,
	loginWithWhatsApp,
	loginGoogle,
	loginWithSms,
	showCustomLogin,
	fallBackLogin,
	showLoginGoogle,
	successRoute,
	goToFallbackBusinessPage,
	successTitle,
	successSubtitle,
	successButtonText,
	hideSuccessButton = false,
	bookingLoading = false,
}) {
	const { t } = useTranslation();
	const classes = useStyles();
	const [animationKey, setAnimationKey] = useState(0);
	const [handleFallback, setHandleFallback] = useState(false);

	const close = () => {
		setHandleFallback(true);
		onClose();
	}
	
	useEffect(() => {
		if (open) {
			document.body.style.overflow = "hidden";
			setAnimationKey((prev) => prev + 1);
		} else {
			document.body.style.overflow = "unset";
		}

		return () => {
			document.body.style.overflow = "unset";
		};
	}, [open]);

	if (!open) return null;

	const handleBackdropClick = (e) => {
		if (e.target === e.currentTarget) {
		}
	};


	return (
		<>
			<div
				onClick={handleBackdropClick}
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "rgba(0, 0, 0, 0.5)",
					zIndex: 1299,
					animation: "fadeIn 0.3s ease-out",
				}}
			/>

			<div key={animationKey} className={status === "SUCCESS" ? classes.containerSuccess : classes.container}>
				{(onClose) && (
					<div className={classes.closeButton} onClick={close}>
						<Close style={{ fontSize: 20, color: "#666" }} />
					</div>
				)}
				
				<div className={classes.containerChildren}>
					<DialogWhatsAppAuth
						status={status}
						onFinalize={handleFinalizeAuth}
        				loading={isLoading || checkoutLoading}
        				title={successTitle || t("Phone validated successfully")}
        				subtitle={successSubtitle || t("Now you can finalize your appointment")}
        				buttonText={successButtonText || t("Finalize appointment")}
						checkoutInformation={checkoutInformation}
						schedulingServicePackage={schedulingServicePackage}
						questions={questions}
						observation={observation}
						onFinalizeAppointment={onFinalizeAppointment}
						observationTextField={observationTextField}
						setErrorObservation={setErrorObservation}
						onStartLoading={onStartLoading}
						loginWithWhatsApp={loginWithWhatsApp}
						loginGoogle={loginGoogle}
						loginWithSms={loginWithSms}
						showCustomLogin={showCustomLogin}
						fallBackLogin={fallBackLogin}
						showLoginGoogle={showLoginGoogle}
						successRoute={successRoute}
						onClose={onClose}
						handleFallback={handleFallback}
						goToFallbackBusinessPage={goToFallbackBusinessPage}
						hideSuccessButton={hideSuccessButton}
						bookingLoading={bookingLoading}
					/>
				</div>
			</div>

			<style>
				{`
					@keyframes fadeIn {
						from {
							opacity: 0;
						}
						to {
							opacity: 1;
						}
					}
				`}
			</style>
		</>
	);
}

